var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 20.25L15.75 20.25",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58665 13.1613L5.12059 16.4744C5.59144 16.9158 6.19209 17.1936 6.83336 17.2665C7.47463 17.3395 8.12232 17.2037 8.68028 16.8793L22.8747 8.62667L21.1273 6.49092C20.674 5.93685 20.0374 5.56315 19.3327 5.43733C18.6279 5.31151 17.9014 5.44186 17.2844 5.80483L13.1247 8.25167L7.49973 6.37667L5.95295 7.03958C5.83723 7.08917 5.73586 7.1671 5.65817 7.26618C5.58049 7.36526 5.529 7.4823 5.50845 7.60652C5.4879 7.73073 5.49895 7.85812 5.54058 7.97694C5.58221 8.09576 5.65309 8.20218 5.74667 8.28641L8.62473 10.8767L5.99973 12.3767L3.37473 11.2517L1.80417 11.9248C1.68963 11.9739 1.58913 12.0507 1.51175 12.1484C1.43437 12.2461 1.38254 12.3615 1.36095 12.4842C1.33936 12.6069 1.34869 12.7331 1.3881 12.8513C1.4275 12.9695 1.49575 13.0761 1.58665 13.1613V13.1613Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/Flight.726bd3421a305c6ed9755ca5f96e987e.svg";
export { ForwardRef as ReactComponent };